<template>
    <div>
        <section class="content-header">
            <h1>
                <span>{{ $ml.get('shared.payrollManagement') }}</span>
            </h1>
            <ol class="breadcrumb">
                <li>
                    <i class="fa fa-dashboard"></i>
                    <span>{{ $ml.get('shared.dashboard') }}</span>
                </li>
                <li>
                    <span>{{ $ml.get('shared.payrollManagement') }}</span>
                </li>
            </ol>
        </section>
        <section class="content">
            <div class="row" style="padding-bottom:10px">
                <div class="col-sm-12 col-md-5" style="padding-bottom:10px;">
                    <div class="input-group" style="margin-top:25px;">
                        <input type="text" :placeholder="$ml.get('employees.searchEmployeeInList')" v-model="searchText"
                            class="form-control" autocomplete="false" />
                        <span class="input-group-btn">
                            <button :disabled="isLoading" type="button" class="btn btn-danger" style="width:100%;"
                                data-toggle="modal" data-target="#modal-filtre">
                                <i class="fa fa-filter"></i> Kişileri Filtrele
                            </button>
                        </span>
                    </div>
                </div>
                <div class="col-sm-6 col-md-3" style="padding-bottom:5px">
                    <div class="form-group">
                        <label>Takvim</label>
                        <input :disabled="isLoading" @change="getDateOfIsOWeek()" type="week" class="form-control"
                            v-model="selectedWeek" />
                    </div>
                </div>
                <div class="col-sm-6 col-md-4" style="padding-bottom:5px;margin-top:25px;">
                    <button class="btn btn-primary" style="width: 100%;" @click="getDateOfIsOWeek()"><i
                            class="fa fa-search"></i> {{ $ml.get('general.view') }}</button>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-9">
                    <div class="box box-primary">
                        <div class="box-header with-border">
                            <i class="fa fa-calendar"></i>
                            <h3 class="box-title">
                                <span>Çalışma Planı Takvimi</span>
                            </h3>
                            <div class="box-tools pull-right">
                                <button @click="exportToPDF()" type="button" class="btn btn-danger btn-sm">
                                    <i class="fa fa-share"></i>
                                    {{ $ml.get('general.exportToPdfOrPrint') }}
                                </button>
                            </div>
                        </div>
                        <div class="box-body">
                            <div id="printShiftPlan" v-show="employeeList.length > 0 && shiftList.length > 0"
                                class="table-responsive no-padding" :style="windowHeightSize">
                                <table class="table table-hover table-bordered table-striped table-condensed">
                                    <thead>
                                        <tr>
                                            <th style="vertical-align:middle;">
                                                <strong>{{ $ml.get('employees.nameSurname') }}</strong>
                                            </th>
                                            <th class="text-center" style="vertical-align:middle;"
                                                v-for="(day, index) in dayList" :key="index">{{ day }}<br />{{ day |
                                                    gunAdi }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="employee1 in shiftList" :key="employee1.empId">
                                            <td style="vertical-align:middle;">
                                                <span class="text-muted">{{ employee1.terminalNo | fixedFive
                                                }}</span><br />
                                                <span style="text-weight:bold">{{ employee1.name }}</span>
                                                <br />
                                                <span v-show="employee1.title" class="text-muted">{{ employee1.title
                                                }}</span>
                                            </td>
                                            <td v-for="(shift, index) in employee1.shifts"
                                                :key="employee1.empId + '-' + index"
                                                :class="checkListControl(shift, employee1.empId) ? 'text-center selected-shift' : 'text-center'"
                                                style="vertical-align: middle;cursor:pointer;"
                                                @click="!selectedAllowence.id && !selectedWorkGroup.id ? selectShift(shift, employee1) : selectBatchShift(shift)">
                                                <a href="#" v-show="shift.allowenceId == null && shift.workGroupId == 0"
                                                    class>
                                                    <i class="fa fa-info-circle"></i> Planlanmadı
                                                </a>
                                                <hr v-show="(shift.allowenceId == null && shift.workGroupId == 0) && (shift.entry || shift.exit)"
                                                    style="margin-top: 5px;margin-bottom: 5px;" />
                                                <span v-show="shift.entry" :class="bgColorShiftEntry(shift)"
                                                    style="padding:10px;margin-bottom:5px;">{{ shift.entry |
                                                        toDateFormatGet("ss:dd") }}</span>
                                                <span v-show="shift.exit" :class="bgColorShiftExit(shift)"
                                                    style="padding:10px;margin-bottom:5px;">{{ shift.exit |
                                                        toDateFormatGet("ss:dd") }}</span>
                                                <hr v-show="(shift.entry || shift.exit) && (shift.allowenceId || shift.workGroupId)"
                                                    style="margin-top: 5px;margin-bottom: 5px;" />
                                                <span v-show="shift.workGroupId" style="padding: 5px 5px 0px 5px;">
                                                    {{ shift.workGroupName }}</span>
                                                <span v-show="shift.allowenceId" class="badge"
                                                    :style="bgColorAllowence(shift.allowenceId) + 'padding:10px;'">{{
                                                        shift.allowenceName }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-show="employeeList.length == 0 || shiftList.length == 0"
                                class="callout callout-info">
                                <i class="fa fa-info-circle"></i>
                                {{ $ml.get("alerts.recordNotFound") }}
                            </div>
                        </div>
                        <div class="overlay" id="load" :hidden="!isLoading">
                            <i class="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <h4 class="text-center text-bold" v-show="selectedWorkGroup.id || selectedAllowence.id">
                        <span>{{ selectedWorkGroup.id ? selectedWorkGroup.name : selectedAllowence.name }}</span>
                    </h4>
                    <div class="row">
                        <div v-show="selectedBatchShiftList.length > 0" class="col-sm-6">
                            <button class="btn btn-success btn-block" :disabled="isLoading" @click="saveBatchShift()">
                                <i class="fa fa-check"></i>
                                {{ $ml.get('general.update') }}
                            </button>
                        </div>
                        <div :class="selectedBatchShiftList.length > 0 ? 'col-sm-6' : 'col-sm-12'">
                            <button v-show="selectedWorkGroup.id || selectedAllowence.id" :disabled="isLoading"
                                class="btn btn-danger btn-block" @click="clearSelectedBatchShift()">
                                <i class="fa fa-remove"></i>
                                {{ $ml.get('general.cancel') }}
                            </button>
                        </div>
                    </div>
                    <div class="box box-primary" v-show="!selectedWorkGroup.id && !selectedAllowence.id">
                        <div class="box-header with-border" style="cursor:pointer;"
                            @click="workGroupIsActive = !workGroupIsActive">
                            <i class="fa fa-calendar"></i>
                            <h3 class="box-title">
                                <span>Çalışma Planları</span>
                            </h3>
                            <div class="box-tools pull-right">
                                <button type="button" class="btn btn-box-tool">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div class="box-body" v-show="workGroupIsActive">
                            <ul>
                                <li v-for="workGroup in workGroupList" :key="workGroup.id">
                                    <span style="cursor:pointer;"
                                        :class="selectedWorkGroup.id == workGroup.id ? 'text-primary text-bold' : ''"
                                        @click="selectWorkGroup(workGroup)">{{
                                            workGroup.name }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="box box-primary" v-show="!selectedWorkGroup.id && !selectedAllowence.id">
                        <div class="box-header with-border" style="cursor:pointer;"
                            @click="allowenceIsActive = !allowenceIsActive">
                            <i class="fa fa-calendar"></i>
                            <h3 class="box-title">
                                <span>İzinler</span>
                            </h3>
                            <div class="box-tools pull-right">
                                <button type="button" class="btn btn-box-tool">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div class="box-body" v-show="allowenceIsActive">
                            <ul>
                                <li v-for="allowence in allowenceList" :key="allowence.id">
                                    <span style="cursor:pointer;"
                                        :class="selectedAllowence.id == allowence.id ? 'text-primary text-bold' : ''"
                                        @click="selectAllowence(allowence)">{{
                                            allowence.name }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.MODAL START-->
            <div class="modal modal-primary fade" id="modal-filtre">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title">
                                <span>{{ $ml.get('filters.filterEmployees') }}</span>
                            </h4>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <span>{{ $ml.get('filters.filterNameSurnameOrCardNo') }}</span>
                                        <input v-model="filters.nameOrCardNumber" type="text"
                                            class="form-control input-sm"
                                            :placeholder="$ml.get('filters.filterNameSurnameOrCardNo')"
                                            style="margin-bottom:5px;" />
                                    </div>
                                    <div class="form-group">
                                        <span>{{ $ml.get('filters.filterCitizenshipNumber') }}</span>
                                        <input v-model="filters.identityNo" type="text" class="form-control input-sm"
                                            :placeholder="$ml.get('filters.filterCitizenshipNumber')"
                                            style="margin-bottom:5px;" />
                                    </div>
                                    <div class="form-group">
                                        <span>{{ $ml.get('filters.filterRegistrationOrDeviceNo') }}</span>
                                        <input v-model="filters.sicilOrTerminalNo" type="text"
                                            class="form-control input-sm"
                                            :placeholder="$ml.get('filters.filterRegistrationOrDeviceNo')"
                                            style="margin-bottom:5px;" />
                                    </div>
                                    <div class="form-group">
                                        <span>{{ $ml.get('filters.filterTitle') }}</span>
                                        <select @change="changeFilterTitles($event)" class="form-control input-sm"
                                            style="margin-bottom:5px;">
                                            <option :selected="filters.title == ''" value>{{ $ml.get('general.select')
                                            }}
                                            </option>
                                            <option v-for="title in titleList" :key="title.name" :value="title.name"
                                                :selected="title.name == filters.title">{{ title.name }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label>{{ $ml.get('filters.filterStatus') }}</label>
                                        <div class="input-group">
                                            <label v-show="checkedStatusList != ''" class="form-control tdb-box">{{
                                                checkedStatusList }}</label>
                                            <label v-show="checkedStatusList == ''" class="form-control">{{
                                                $ml.get('general.notSelected') }}</label>
                                            <div class="input-group-btn">
                                                <button class="btn btn-default" data-toggle="modal"
                                                    data-target="#modal-select-status">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                                <button v-show="checkedStatusList != ''" class="btn btn-danger"
                                                    @click="clearFilterStatus()">
                                                    <i class="fa fa-remove"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <span v-if="modules.customFieldName == ''">{{
                                            $ml.get('filters.filterDocumentNoOrEmail') }}</span>
                                        <span v-else>{{ modules.customFieldName + ' / ' +
                                            $ml.get('filters.filterDocumentNoOrEmail') }}</span>
                                        <input v-model="filters.documentNoOrMail" type="text"
                                            class="form-control input-sm"
                                            :placeholder="modules.customFieldName != '' ? modules.customFieldName + ' / ' + $ml.get('filters.filterDocumentNoOrEmail') : $ml.get('filters.filterDocumentNoOrEmail')"
                                            style="margin-bottom:5px;" />
                                    </div>
                                    <div class="form-group" v-show="modules.licencePlateRecognition">
                                        <span>{{ $ml.get('filters.filterPlateNo') }}</span>
                                        <input v-model="filters.plateNo" type="text" class="form-control input-sm"
                                            :placeholder="$ml.get('filters.filterPlateNo')"
                                            style="margin-bottom:5px;" />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>{{ $ml.get('filters.filterDepartments') }}</label>
                                        <div class="input-group">
                                            <label v-show="checkedDepartmentList != ''" class="form-control tdb-box">{{
                                                checkedDepartmentList }}</label>
                                            <label v-show="checkedDepartmentList == ''" class="form-control">{{
                                                $ml.get('general.notSelected') }}</label>
                                            <div class="input-group-btn">
                                                <button class="btn btn-default" data-toggle="modal"
                                                    data-target="#modal-select-department">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                                <button v-show="checkedDepartmentList != ''" class="btn btn-danger"
                                                    @click="clearFilterDepartments()">
                                                    <i class="fa fa-remove"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{ $ml.get('filters.filterAccessGroup') }}</label>
                                        <div class="input-group">
                                            <label v-show="checkedAccessGroupList != ''" class="form-control tdb-box">{{
                                                checkedAccessGroupList }}</label>
                                            <label v-show="checkedAccessGroupList == ''" class="form-control">{{
                                                $ml.get('general.notSelected') }}</label>
                                            <div class="input-group-btn">
                                                <button class="btn btn-default" data-toggle="modal"
                                                    data-target="#modal-select-access">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                                <button v-show="checkedAccessGroupList != ''" class="btn btn-danger"
                                                    @click="clearFilterAccessGroup()">
                                                    <i class="fa fa-remove"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{ $ml.get('filters.filterWorkPlan') }}</label>
                                        <div class="input-group">
                                            <label v-show="checkedWorkGroupList != ''" class="form-control tdb-box">{{
                                                checkedWorkGroupList }}</label>
                                            <label v-show="checkedWorkGroupList == ''" class="form-control">{{
                                                $ml.get('general.notSelected') }}</label>
                                            <div class="input-group-btn">
                                                <button class="btn btn-default" data-toggle="modal"
                                                    data-target="#modal-select-workplan">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                                <button v-show="checkedWorkGroupList != ''" class="btn btn-danger"
                                                    @click="clearFilterWorkPlans()">
                                                    <i class="fa fa-remove"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group" v-show="modules.diningHall">
                                        <label>{{ $ml.get('filters.filterFoodGroup') }}</label>
                                        <div class="input-group">
                                            <label v-show="checkedFoodGroupList != ''" class="form-control tdb-box">{{
                                                checkedFoodGroupList }}</label>
                                            <label v-show="checkedFoodGroupList == ''" class="form-control">{{
                                                $ml.get('general.notSelected') }}</label>
                                            <div class="input-group-btn">
                                                <button class="btn btn-default" data-toggle="modal"
                                                    data-target="#modal-select-diningHall">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                                <button v-show="checkedFoodGroupList != ''" class="btn btn-danger"
                                                    @click="clearFilterFoodGroups()">
                                                    <i class="fa fa-remove"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{ $ml.get('filters.filterState') }}</label>
                                        <div class="input-group">
                                            <label v-show="checkedStateList != ''" class="form-control tdb-box">{{
                                                checkedStateList }}</label>
                                            <label v-show="checkedStateList == ''" class="form-control">{{
                                                $ml.get('general.notSelected') }}</label>
                                            <div class="input-group-btn">
                                                <button class="btn btn-default" data-toggle="modal"
                                                    data-target="#modal-select-state">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                                <button v-show="checkedStateList != ''" class="btn btn-danger"
                                                    @click="clearFilterStates()">
                                                    <i class="fa fa-remove"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-sm-6">
                                            <span>{{ $ml.get('filters.filterDeleted') }}</span>
                                            <span class="form-control checkbox">
                                                <label style="margin-left:20px;">
                                                    <input :checked="filters.isActive"
                                                        @change="filters.isActive == true ? filters.isActive = false : filters.isActive = true"
                                                        type="checkbox" />
                                                    {{ $ml.get('filters.filterNotShow') }}
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="callout callout-info" style="margin-top:10px;">
                                <div class="row">
                                    <div class="col-md-3 col-xs-6">
                                        <select @change="changeFilterExtraField1($event)" class="form-control input-sm"
                                            style="margin-bottom:5px;">
                                            <option :selected="filters.extraField1key == 0" value>
                                                {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                                            <option v-for="extraField in extraFieldList" :key="extraField.id"
                                                :value="extraField.id"
                                                :selected="extraField.id == filters.extraField1key">{{ extraField.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 col-xs-6">
                                        <input v-model="filters.extraField1value" type="text"
                                            class="form-control input-sm" :placeholder="$ml.get('filters.filterValue')"
                                            style="margin-bottom:5px;" />
                                    </div>
                                    <div class="col-md-3 col-xs-6">
                                        <select @change="changeFilterExtraField2($event)" class="form-control input-sm"
                                            style="margin-bottom:5px;">
                                            <option :selected="filters.extraField2key == 0" value>
                                                {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                                            <option v-for="extraField in extraFieldList" :key="extraField.id"
                                                :value="extraField.id"
                                                :selected="extraField.id == filters.extraField2key">{{ extraField.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 col-xs-6">
                                        <input v-model="filters.extraField2value" type="text"
                                            class="form-control input-sm" :placeholder="$ml.get('filters.filterValue')"
                                            style="margin-bottom:5px;" />
                                    </div>
                                    <div class="col-md-3 col-xs-6">
                                        <select @change="changeFilterExtraField3($event)" class="form-control input-sm"
                                            style="margin-bottom:5px;">
                                            <option :selected="filters.extraField3key == 0" value>
                                                {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                                            <option v-for="extraField in extraFieldList" :key="extraField.id"
                                                :value="extraField.id"
                                                :selected="extraField.id == filters.extraField3key">{{ extraField.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 col-xs-6">
                                        <input v-model="filters.extraField3value" type="text"
                                            class="form-control input-sm" :placeholder="$ml.get('filters.filterValue')"
                                            style="margin-bottom:5px;" />
                                    </div>
                                    <div class="col-md-3 col-xs-6">
                                        <select @change="changeFilterExtraField4($event)" class="form-control input-sm"
                                            style="margin-bottom:5px;">
                                            <option :selected="filters.extraField4key == 0" value>
                                                {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                                            <option v-for="extraField in extraFieldList" :key="extraField.id"
                                                :value="extraField.id"
                                                :selected="extraField.id == filters.extraField4key">{{ extraField.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 col-xs-6">
                                        <input v-model="filters.extraField4value" type="text"
                                            class="form-control input-sm" :placeholder="$ml.get('filters.filterValue')"
                                            style="margin-bottom:5px;" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" data-dismiss="modal">
                            <i class="fa fa-remove"></i>
                            <span>{{ $ml.get('filters.filterCancel') }}</span>
                        </button>
                        <button @click="filtersClear()" class="btn btn-warning">
                            <i class="fa fa-trash-o"></i>
                            <span>{{ $ml.get('filters.filterClear') }}</span>
                        </button>
                        <button @click="getEmployees()" class="btn btn-success" data-dismiss="modal">
                            <i class="fa fa-search"></i>
                            <span>{{ $ml.get('filters.filterApply') }}</span>
                        </button>
                    </div>
                </div>
            </div>
            <!-- /.MODAL END -->
            <!--DEPARTMAN SEÇ MODAL -->
            <div class="modal modal-secondary fade" id="modal-select-department" style="display: none;">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title">
                                <span>{{ $ml.get('filters.filterDepartments') }}</span>
                            </h4>
                        </div>
                        <div class="modal-body">
                            <a
                                @click="isCheckDeps == true ? getCheckDepartmentAll(false) : getCheckDepartmentAll(true)">
                                <span
                                    v-text="isCheckDeps == true ? $ml.get('general.removeAll') : $ml.get('general.selectAll')"></span>
                            </a>
                            <div v-show="sortableDepartmentList.length > 0" class="table-responsive"
                                style="max-height:600px;owerflow:auto;">
                                <span class="form-control checkbox" v-for="dep in sortableDepartmentList" :key="dep.id">
                                    <label style="margin-left:20px;">
                                        <input :checked="dep.check"
                                            @change="dep.check == true ? changeFilterDep(dep, false) : changeFilterDep(dep, true)"
                                            type="checkbox" />
                                        {{ dep.name }}
                                    </label>
                                </span>
                                <div class="callout callout-warning" v-show="sortableDepartmentList.length == 0">
                                    {{ $ml.get('employees.departmentNotRecord') }}</div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">
                                <i class="fa fa-check"></i>
                                {{ $ml.get('general.done') }}
                            </button>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
            <!--DEPARTMAN SEÇ MODAL END -->
            <!--DURUM SEÇ MODAL -->
            <div class="modal modal-secondary fade" id="modal-select-state" style="display: none;">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title">
                                <span>{{ $ml.get('filters.filterState') }}</span>
                            </h4>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                                <span class="form-control checkbox" v-for="state in stateList" :key="state.id">
                                    <label style="margin-left:20px;">
                                        <input :checked="state.isCheck"
                                            @change="state.isCheck == true ? state.isCheck = false : state.isCheck = true"
                                            type="checkbox" />
                                        {{ state.name }}
                                    </label>
                                </span>
                                <div class="callout callout-warning" v-show="stateList.length == 0">
                                    {{ $ml.get('employees.stateNotRecord') }}</div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">
                                <i class="fa fa-check"></i>
                                {{ $ml.get('general.done') }}
                            </button>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
            <!--DURUM SEÇ MODAL END -->
            <!--STATU SEÇ MODAL -->
            <div class="modal modal-secondary fade" id="modal-select-status" style="display: none;">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title">
                                <span>{{ $ml.get('filters.filterStatus') }}</span>
                            </h4>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                                <span class="form-control checkbox" v-for="status in statuList" :key="status.id">
                                    <label style="margin-left:20px;">
                                        <input :checked="status.isCheck"
                                            @change="status.isCheck == true ? status.isCheck = false : status.isCheck = true"
                                            type="checkbox" />
                                        {{ status.name }}
                                    </label>
                                </span>
                                <div class="callout callout-warning" v-show="statuList.length == 0">
                                    {{ $ml.get('employees.statusNotRecord') }}</div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">
                                <i class="fa fa-check"></i>
                                {{ $ml.get('general.done') }}
                            </button>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
            <!--STATU SEÇ MODAL END -->
            <!--GEÇİŞ GRUBU SEÇ MODAL -->
            <div class="modal modal-secondary fade" id="modal-select-access" style="display: none;">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title">
                                <span>{{ $ml.get('filters.filterAccessGroup') }}</span>
                            </h4>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                                <span class="form-control checkbox" v-for="acc in accessGroupList" :key="acc.id">
                                    <label style="margin-left:20px;">
                                        <input :checked="acc.isCheck"
                                            @change="acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true"
                                            type="checkbox" />
                                        {{ acc.name }}
                                    </label>
                                </span>
                                <div class="callout callout-warning" v-show="accessGroupList.length == 0">
                                    {{ $ml.get('accessGroups.accessGroupNotRecord') }}</div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">
                                <i class="fa fa-check"></i>
                                {{ $ml.get('general.done') }}
                            </button>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
            <!--GEÇİŞ GRUBU SEÇ MODAL END -->
            <!--ÇALIŞMA PLANI SEÇ MODAL -->
            <div class="modal modal-secondary fade" id="modal-select-workplan" style="display: none;">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title">
                                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
                            </h4>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                                <span class="form-control checkbox" v-for="work in periodWorkGroupList" :key="work.id">
                                    <label style="margin-left:20px;">
                                        <input :checked="work.isCheck"
                                            @change="work.isCheck == true ? work.isCheck = false : work.isCheck = true"
                                            type="checkbox" />
                                        {{ work.name }}
                                    </label>
                                </span>
                                <div class="callout callout-warning" v-show="periodWorkGroupList.length == 0">
                                    {{ $ml.get('workPlans.workPlanNotRecord') }}</div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">
                                <i class="fa fa-check"></i>
                                {{ $ml.get('general.done') }}
                            </button>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
            <!--ÇALIŞMA PLANI SEÇ MODAL END -->
            <!--YEMEK PLANI SEÇ MODAL -->
            <div class="modal modal-secondary fade" id="modal-select-diningHall" style="display: none;">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title">
                                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
                            </h4>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                                <span class="form-control checkbox" v-for="foodGroup in foodGroupList"
                                    :key="foodGroup.id">
                                    <label style="margin-left:20px;">
                                        <input :checked="foodGroup.isCheck"
                                            @change="foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true"
                                            type="checkbox" />
                                        {{ foodGroup.name }}
                                    </label>
                                </span>
                                <div class="callout callout-warning" v-show="foodGroupList.length == 0">
                                    {{ $ml.get('foodGroups.foodGroupNotRecord') }}</div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">
                                <i class="fa fa-check"></i>
                                {{ $ml.get('general.done') }}
                            </button>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
            <!--YEMEK PLANI SEÇ MODAL END -->
            <!--SHIFT PLANI SEÇ MODAL -->
            <div class="modal modal-secondary fade" id="modal-shift" style="display: none;">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title">
                                <span>Plan Detayı</span>
                            </h4>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-4">
                                    <span>{{ selectedEmployee.sicilNo }}</span>
                                    <br />
                                    <span class="h4">{{ selectedEmployee.name }}</span>
                                    <br />
                                    <span class="text-muted">{{ selectedEmployee.title }}</span>
                                    <hr />
                                    <span>Tarih</span>
                                    <br />
                                    <span style="font-weight:bold;font-size:large;">{{ selectedShift.date |
                                        toDateFormatGet("gg.aa.yyyy") }} {{ selectedShift.date | gunAdi }}</span>
                                    <br />
                                    <span>Çalışma Saatleri</span>
                                    <br />
                                    <span style="font-weight:bold;font-size:large;">{{ selectedShift.toleranceEntry |
                                        toDateFormatGet("ss:dd") }} - {{ selectedShift.toleranceExit |
                                            toDateFormatGet("ss:dd") }}</span>
                                    <hr />
                                    <div class="form-group">
                                        <label>Çalışma Planı</label>
                                        <select @change="changeWorkGroup($event)"
                                            :class="selectedShift.workGroupId == 0 || selectedShift.workGroupId == null ? 'form-control' : 'form-control label-success'">
                                            <option value="0">Seçilmedi</option>
                                            <option v-for="workGroup in workGroupList" :key="workGroup.id"
                                                :value="workGroup.id"
                                                :selected="workGroup.id == selectedShift.workGroupId">{{ workGroup.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label>İzin</label>
                                        <select @change="changeAllowence($event)"
                                            :class="selectedShift.allowenceId == 0 || selectedShift.allowenceId == null ? 'form-control' : 'form-control label-success'">
                                            <option value="0">Seçilmedi</option>
                                            <option v-for="allowence in allowenceList" :key="allowence.id"
                                                :value="allowence.id"
                                                :selected="allowence.id == selectedShift.allowenceId">{{ allowence.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <hr />
                                    <div class="row">
                                        <div class="col-sm-6 col-xs-6">
                                            <div class="form-group text-center">
                                                <label>İlk Giriş</label><br />
                                                <span class="" style="font-size:14px;padding:7px"
                                                    v-show="selectedShift.entry">{{ selectedShift.entry |
                                                        toDateFormatGet("gg.aa.yyyy") }}</span><br />
                                                <span class="" style="font-size:14px;margin-top: 5px;padding:7px;"
                                                    v-show="selectedShift.entry">{{ selectedShift.entry |
                                                        toDateFormatGet("ss:dd") }}</span>
                                                <span v-show="!selectedShift.entry">-</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-xs-6">
                                            <div class="form-group text-center">
                                                <label>Son Çıkış</label><br />
                                                <span class="" style="font-size:14px;padding:7px"
                                                    v-show="selectedShift.exit">{{ selectedShift.exit |
                                                        toDateFormatGet("gg.aa.yyyy") }}</span><br />
                                                <span class="" style="font-size:14px;margin-top: 5px;padding:7px;"
                                                    v-show="selectedShift.exit">{{ selectedShift.exit |
                                                        toDateFormatGet("ss:dd") }}</span>
                                                <span v-show="!selectedShift.exit">-</span>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                </div>
                                <div class="col-sm-4">
                                    <label>Tüm Hareketler</label>
                                    <div v-show="dailyInOutDetailList.length > 0" class="table-responsive no-padding">
                                        <table class="table table-hover">
                                            <tbody>
                                                <tr>
                                                    <th>{{ $ml.get('employees.movementOT') }}</th>
                                                    <th>{{ $ml.get('employees.statusOT') }}</th>
                                                    <th></th>
                                                </tr>
                                                <tr v-for="(inOutDetail, index) in dailyInOutDetailList" :key="index">
                                                    <td>{{ inOutDetail.date }}</td>
                                                    <td>
                                                        <span v-show="inOutDetail.status == 'Giriş'"
                                                            class="label label-success">{{
                                                                $ml.get('employees.entryMovement') }}</span>
                                                        <span v-show="inOutDetail.status == 'Çıkış'"
                                                            class="label label-danger">{{
                                                                $ml.get('employees.exitMovement') }}</span>
                                                    </td>
                                                    <td>
                                                        <button class="btn btn-xs btn-primary" v-show="authControl == 0"
                                                            @click="selectInOut2(inOutDetail)">
                                                            <i class="fa fa-edit"></i>
                                                        </button>
                                                        <button @click="deleteInOut2(inOutDetail.id)" v-show="authControl == 0"
                                                            class="btn btn-xs btn-danger">
                                                            <i class="fa fa-remove"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-show="dailyInOutDetailList.length == 0" class="callout callout-info">
                                        <i class="fa fa-info-circle"></i>
                                        {{ $ml.get('employees.movementNotRecord') }}
                                    </div>
                                    <hr />
                                    <div v-show="isActiveInOut2 == false && modules.saveMovementLog && authControl == 0"
                                        style="margin-top:5px;">
                                        <button type="button" class="btn btn-sm btn-warning"
                                            style="width:100%;margin-bottom:5px;" @click="newInOut2()">
                                            <i class="fa fa-plus"></i>
                                            {{ $ml.get('employees.newMovement') }}
                                        </button>
                                    </div>
                                    <div v-show="isActiveInOut2 == true" style="margin-top:5px;">
                                        <div class="form-group">
                                            <label>{{ $ml.get('employees.timeMovement') }}</label>
                                            <input v-model="inOut2.inOutAdd" type="datetime-local"
                                                class="form-control input-sm" />
                                        </div>
                                        <div class="form-group">
                                            <label>{{ $ml.get('employees.readerMovement') }}</label>
                                            <select @change="changeInOutDoor2($event)" class="form-control input-sm">
                                                <option value="0" :selected="inOut2.inOutType == 0">{{
                                                    $ml.get('general.notSelected') }}</option>
                                                <option v-for="door in activePDKSReaderList" :key="door.readerId"
                                                    :value="door.readerId" :selected="door.readerId == inOut2.readerId">
                                                    {{ door.name }}</option>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label>{{ $ml.get('employees.typeMovement') }}</label>
                                            <select @change="changeInOutType2($event)" class="form-control input-sm">
                                                <option value="0" :selected="inOut2.inOutType == 0">{{
                                                    $ml.get('general.notSelected') }}</option>
                                                <option value="1" :selected="inOut2.inOutType == 1">{{
                                                    $ml.get('employees.entryMovement') }}
                                                </option>
                                                <option value="2" :selected="inOut2.inOutType == 2">{{
                                                    $ml.get('employees.exitMovement') }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <span class="checkbox">
                                                <label style="margin-left:20px;">
                                                    <input :checked="includePassiveMovements"
                                                        @change="includePassiveMovements == true ? includePassiveMovements = false : includePassiveMovements = true"
                                                        type="checkbox" />
                                                    {{ $ml.get('employees.includePassivesMovement') }}
                                                </label>
                                            </span>
                                        </div>
                                        <div class="form-group">
                                            <span class="checkbox">
                                                <label style="margin-left:20px;">
                                                    <input :checked="doNotDeleteOvertimes"
                                                        @change="doNotDeleteOvertimes == true ? doNotDeleteOvertimes = false : doNotDeleteOvertimes = true"
                                                        type="checkbox" />
                                                    {{ $ml.get('employees.confirmedOvertimeNotDeleted') }}
                                                </label>
                                            </span>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <button v-show="isNewInOut2 && authControl == 0" type="button" @click="addInOut2()"
                                                    class="btn btn-success" style="width:100%;">{{
                                                        $ml.get('general.save')
                                                    }}</button>
                                                <button v-show="!isNewInOut2 && authControl == 0" type="button" @click="updateInOut2()"
                                                    class="btn btn-success" style="width:100%;">{{
                                                        $ml.get('general.update')
                                                    }}</button>
                                            </div>
                                            <div class="col-sm-6">
                                                <button type="button" @click="isActiveInOut2 = false"
                                                    class="btn btn-danger" style="width:100%;">{{
                                                        $ml.get('general.cancel')
                                                    }}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <label>Puantaj Detayı</label>
                                    <div v-show="dailyPayrollDetailList.length > 0" class="table-responsive no-padding">
                                        <table class="table table-hover">
                                            <tbody>
                                                <tr>
                                                    <th>{{ $ml.get('employees.payrollTime') }}</th>
                                                    <th>{{ $ml.get('employees.payroll') }}</th>
                                                </tr>
                                                <tr v-for="(payrollDetail, index) in dailyPayrollDetailList"
                                                    :key="index">
                                                    <td>{{ payrollDetail.time }}</td>
                                                    <td>
                                                        <span>{{ payrollDetail.payroll }}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-show="dailyPayrollDetailList.length == 0" class="callout callout-info">
                                        <i class="fa fa-info-circle"></i>
                                        {{ $ml.get('employees.payrollNotRecord') }}
                                    </div>
                                    <hr />
                                    <div class="row">
                                        <div class="form-group col-sm-12 col-md-6 text-center">
                                            <span>{{ $ml.get('employees.calculatedOvertimeLong') }}</span>
                                            <label class="form-control">{{ selectedDailyPayrol.calculatedOverTime
                                                }}</label>
                                        </div>
                                        <div class="form-group col-sm-12 col-md-6 text-center">
                                            <span>{{ $ml.get('employees.confirmedOvertimeLong') }}</span>
                                            <input :disabled="selectedDailyPayrol.overTimeId == null" type="time"
                                                class="form-control" style="color:black;"
                                                v-model="selectedDailyPayrol.confirmedOverTime" />
                                        </div>
                                    </div>
                                    <div v-show="selectedDailyPayrol.overTimeId != null" class="form-group">
                                        <span>{{ $ml.get('employees.overtimePlace') }}</span>
                                        <select @change="changeOvertimePlace($event)" class="form-control">
                                            <option :selected="selectedOTPlaceId == null" value>{{
                                                $ml.get('general.notSelected') }}</option>
                                            <option :selected="place.id == selectedOTPlaceId"
                                                v-for="place in overtimePlaceList" :key="place.id" :value="place.id">{{
                                                    place.name }}</option>
                                        </select>
                                    </div>
                                    <div v-show="selectedDailyPayrol.overTimeId != null" class="form-group">
                                        <span>{{ $ml.get('employees.overtimeDescription') }}</span>
                                        <select @change="changeOvertimeDescription($event)" class="form-control">
                                            <option :selected="selectedOTDescriptionId == null" value>{{
                                                $ml.get('general.notSelected') }}
                                            </option>
                                            <option :selected="description.id == selectedOTDescriptionId"
                                                v-for="description in overtimeDescriptionList" :key="description.id"
                                                :value="description.id">
                                                {{ description.name }}</option>
                                        </select>
                                    </div>
                                    <button v-show="selectedDailyPayrol.overTimeId != null" type="button"
                                        @click="customConfirmOverTime()" class="btn btn-primary btn-sm"
                                        style="width:100%;">{{ $ml.get('general.confirm')
                                        }}</button>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="saveChangePayroll()" type="button" class="btn btn-primary">
                                <i class="fa fa-refresh"></i>
                                {{ $ml.get('general.update') }}
                            </button>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
            <!--SHIFT PLANI SEÇ MODAL END -->
        </section>
    </div>
</template>
<script>
import { h } from 'vue';

export default {
    data() {
        return {
            isLoading: false,
            workGroupIsActive: false,
            allowenceIsActive: false,
            selectedAllowence: {
                id: null,
                name: "",
            },
            selectedWorkGroup: {
                id: null,
                name: "",
            },
            selectedBatchShiftList: [],
            windowHeight: window.innerHeight,
            searchText: "",
            orderEmpList: 1,
            isConfirm: true,
            isForbidden: false,
            startDateNow: null,
            endDateNow: null,
            year: 0,
            monthOrWeekNumber: 0,
            selectedEmployee: {
                empId: null,
                sicilNo: "",
                name: "",
                title: "",
                terminalNo: ""
            },
            selectedShift: {
                id: null,
                empId: null,
                date: null,
                entry: null,
                exit: null,
                toleranceEntry: null,
                toleranceExit: null,
                allowenceId: null,
                allowenceName: "",
                confirmedUserId: null,
                confirmStatus: 0,
                workGroupId: null,
                workGroupName: ""
            },
            readers: [],
            includePassiveMovements: false,
            doNotDeleteOvertimes: false,
            isNewInOut2: true,
            isActiveInOut2: false,
            inOut2: {
                inOutId: null,
                inOutListType: 0,
                inOutListDoorType: 4,
                inOutType: 0,
                inOutAdd: "",
                readerId: "0"
            },
            overtimeDescriptions: [],
            overtimePlaces: [],
            selectedOTPlaceId: null,
            selectedOTDescriptionId: null,
            selectedDailyPayrol: {
                date: "",
                workGroup: "",
                movements: [],
                payrolls: [],
                calculatedOverTime: "00:00",
                confirmedOverTime: "00:00",
                overTimeId: null
            },
            selectedWeek: null,
            selectedDays: [],
            filters: {
                nameOrCardNumber: "",
                sicilOrTerminalNo: null,
                departments: [],
                accessGroup: [],
                identityNo: "",
                documentNoOrMail: "",
                foodGroup: [],
                workGroupId: [],
                title: "",
                stateId: [],
                statuId: [],
                plateNo: "",
                extraField1key: 0,
                extraField1value: "",
                extraField2key: 0,
                extraField2value: "",
                extraField3key: 0,
                extraField3value: "",
                extraField4key: 0,
                extraField4value: "",
                isVisitor: false,
                isActive: true
            },
            isCheckDeps: false,
            extrafields: [],
            workGroups: [],
            status: [],
            states: [],
            foodGroups: [],
            titles: [],
            accessGroups: [],
            departments: [],
            sortableDepTrees: [],
            colorPalette: [
                "background-color:#ecf0f5;color:#333333;",
                "background-color:#758ead;color:#ffffff;",
                "background-color:#9d75ad;color:#ffffff;",
                "background-color:#dd9999;color:#333333;",
                "background-color:#d4dd99;color:#333333;",
                "background-color:#99cbdd;color:#333333;",
                "background-color:#d599dd;color:#333333;",
                "background-color:#f1ba98;color:#333333;",
                "background-color:#77b8bf;color:#333333;",
                "background-color:#7782bf;color:#ffffff;"
            ],
            shifts: [],
            allowences: [],
            employeeAllCheck: false,
            employees: [],
            employee: {
                id: null,
                name: "",
                title: "",
                sicilNo: "",
                image: null,
                departmentId: null,
                identityNo: "",
                terminalNo: null
            },
        };
    },
    computed: {
        getAuthType() {
            return this.$store.getters.getUser.authType;
        },
        getShiftAuthority() {
            return this.$store.getters.getAuthority.shiftYetkileri;
        },
        authControl() {
            return this.$store.getters.getAuthTanimlamalar;
        },
        readerList() {
            return this.readers.sort((a, b) => {
                if (a.ipAddress < b.ipAddress) return -1;
                if (a.ipAddress > b.ipAddress) return 0;
            });
        },
        activePDKSReaderList() {
            return this.readerList.filter(item => {
                return item.isActive == true && item.doorType == 1;
            });
        },
        dailyPayrollDetailList() {
            return this.selectedDailyPayrol.payrolls;
        },
        dailyInOutDetailList() {
            return this.selectedDailyPayrol.movements;
        },
        overtimeDescriptionList() {
            return this.overtimeDescriptions;
        },
        overtimePlaceList() {
            return this.overtimePlaces;
        },
        isAdmin() {
            if (
                (this.getShiftAuthority.canPlan &&
                    this.getShiftAuthority.canConfirmShift) ||
                (this.getShiftAuthority.canPlanAllowence &&
                    this.getShiftAuthority.canConfirmAllowence)
            ) {
                return true;
            } else {
                return false;
            }
        },
        shiftDateAuth() {
            var now = new Date();
            var start = this.dayList[0];
            var startDay = start.substring(0, 2);
            var startMonth = start.substring(3, 5);
            var startYear = start.substring(6, 10);
            var startDate = new Date(startYear + "-" + startMonth + "-" + startDay);
            var end = this.dayList[this.dayList.length - 1];
            var endDay = end.substring(0, 2);
            var endMonth = end.substring(3, 5);
            var endYear = end.substring(6, 10);
            var endDate = new Date(endYear + "-" + endMonth + "-" + endDay);
            if (startDate >= now && endDate <= now) {
                return true;
            } else if (startDate < now) {
                return false;
            } else {
                return true;
            }
            return true;
        },
        shiftAuthStatus() {
            if (
                this.monthOrWeekNumber != 0 &&
                this.year != 0 &&
                this.dayList.length > 0
            ) {
                if (this.isAdmin) {
                    return true; //Admin ise tam yetkiye sahip
                } else {
                    return !this.isForbidden;
                }
            } else {
                return false;
            }
        },
        defaultFilters() {
            return this.$store.getters.getDefaultFilters;
        },
        modules() {
            return this.$store.getters.getModules;
        },
        dayList() {
            return this.selectedDays;
        },
        shiftList() {
            if (this.searchText) {
                return this.shifts.filter(item => {
                    return this.searchText
                        .toUpperCase()
                        .split(" ")
                        .every(
                            v =>
                                item.name.toUpperCase().includes(v) ||
                                item.sicilNo.toUpperCase().includes(v)
                        );
                });
            } else {
                return this.shifts;
            }
        },
        allowenceList() {
            return this.allowences;
        },
        departmentList() {
            return this.departments;
        },
        sortableDepartmentList() {
            return this.sortableDepTrees;
        },
        checkedDepartmentList() {
            var checkedList = "";
            var list = this.sortableDepTrees.forEach(a => {
                if (a.check == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        employeeList() {
            if (this.orderEmpList == 1) {
                return this.employees.sort((a, b) => {
                    return a.sicilNo.toUpperCase().localeCompare(b.sicilNo.toUpperCase());
                });
            } else if (this.orderEmpList == 2) {
                return this.employees.sort((a, b) => {
                    return b.sicilNo.toUpperCase().localeCompare(a.sicilNo.toUpperCase());
                });
            } else if (this.orderEmpList == 3) {
                return this.employees.sort((a, b) => {
                    return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
                });
            } else {
                return this.employees.sort((a, b) => {
                    return b.name.toUpperCase().localeCompare(a.name.toUpperCase());
                });
            }
        },
        titleList() {
            return this.titles;
        },
        stateList() {
            return this.states;
        },
        checkedStateList() {
            var checkedList = "";
            var list = this.stateList.forEach(a => {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        statuList() {
            return this.status;
        },
        checkedStatusList() {
            var checkedList = "";
            var list = this.statuList.forEach(a => {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        extraFieldList() {
            return this.extrafields;
        },
        workGroupList() {
            return this.workGroups;
        },
        periodWorkGroupList() {
            return this.workGroups.filter(item => {
                return item.isPeriod == true || item.model == 4 || item.model == 3;
            });
        },
        checkedWorkGroupList() {
            var checkedList = "";
            var list = this.periodWorkGroupList.forEach(a => {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        accessGroupList() {
            return this.accessGroups;
        },
        checkedAccessGroupList() {
            var checkedList = "";
            var list = this.accessGroupList.forEach(a => {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        foodGroupList() {
            return this.foodGroups;
        },
        checkedFoodGroupList() {
            var checkedList = "";
            var list = this.foodGroupList.forEach(a => {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        windowHeightSize() {
            if (this.windowHeight) {
                let height = this.windowHeight - 220;
                return "max-height:" + height + "px;overflow:auto;";
            } else {
                return "max-height:370px;overflow:auto;";
            }
        }
    },
    filters: {
        fixedFive(str) {
            var str2 = "" + str;
            var pad = "00000";
            return pad.substring(0, pad.length - str2.length) + str2;
        },
        gunAdi(tarihStr) {
            if (!tarihStr) return "";

            let tarih; // örn: "26.01.2026" veya "2026-02-03T00:00:00"

            // DD.MM.YYYY formatı
            if (tarihStr.includes(".")) {
                const [gun, ay, yil] = tarihStr.split(".");
                tarih = new Date(yil, ay - 1, gun);
            }
            // ISO format: YYYY-MM-DDTHH:mm:ss
            else {
                tarih = new Date(tarihStr);
            }

            if (isNaN(tarih.getTime())) return "";

            const gunler = [
                "Pazar",
                "Pazartesi",
                "Salı",
                "Çarşamba",
                "Perşembe",
                "Cuma",
                "Cumartesi"
            ];

            return gunler[tarih.getDay()];
        },
        toDateFormatGet(str, format) {
            if (!str) {
                return "";
            }
            str = new Date(str);
            var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
            var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
            var yil = str.getFullYear();
            var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
            var dakika =
                str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
            var saniye =
                str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
            if (format == "gg.aa.yyyy ss:dd") {
                return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
            } else if (format == "gg.aa.yyyy") {
                return gun + "." + ay + "." + yil;
            } else if (format == "ss:dd:ss") {
                return saat + ":" + dakika + ":" + saniye;
            } else if (format == "ss:dd") {
                return saat + ":" + dakika;
            }
        }
    },
    watch: {
        windowHeight(newHeight, oldHeight) {
            if (newHeight < 576) {
                //MOBİL
            } else {
                //WEB
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener("resize", this.onResize);
        });
    },
    methods: {
        toDateFormat(str, format) {
            if (!str) {
                return "";
            }
            str = new Date(str);
            var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
            var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
            var yil = str.getFullYear();
            var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
            var dakika =
                str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
            var saniye =
                str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
            if (format == "gg.aa.yyyy ss:dd") {
                return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
            } else if (format == "gg.aa.yyyy") {
                return gun + "." + ay + "." + yil;
            } else if (format == "yyyy-aa-ggTss:dd") {
                return yil + "-" + ay + "-" + gun + "T" + saat + ":" + dakika;
            } else if (format == "ss:dd:ss") {
                return saat + ":" + dakika + ":" + saniye;
            } else if (format == "ss:dd") {
                return saat + ":" + dakika;
            }
        },
        async getDateOfIsOWeek(event) {
            this.isLoading = true;
            var inp = this.selectedWeek;
            this.year = parseInt(inp.slice(0, 4), 10);
            this.monthOrWeekNumber = parseInt(inp.slice(6), 10);
            await this.getCalendar();
            await this.getRealMovements();
            this.isLoading = false;
        },
        onResize() {
            this.windowHeight = window.innerHeight;
        },
        exportToPDF() {
            this.$htmlToPaper("printShiftPlan");
        },
        bgColorShiftEntry(shift) {
            if (shift.toleranceEntry) {
                if (shift.entry > shift.toleranceEntry) {
                    return "badge label-danger";
                } else {
                    return "badge default-label";
                }
            } else {
                return "badge default-label";
            }
        },
        bgColorShiftExit(shift) {
            if (shift.toleranceExit) {
                if (shift.exit < shift.toleranceExit) {
                    return "badge label-danger";
                } else {
                    return "badge default-label";
                }
            } else {
                return "badge default-label";
            }
        },
        bgColorAllowence(allowenceId) {
            if (allowenceId) {
                var list = this.allowenceList.filter(a => {
                    return a.id == allowenceId;
                });
                if (list[0]) {
                    return "background-color: rgb(" + list[0].r + "," + list[0].g + "," + list[0].b + ");color:#ffffff;";
                } else {
                    return "";
                }
            } else {
                return "";
            }
        },
        setOrderEmp(number) {
            if (number == 1) {
                if (this.orderEmpList == 1) {
                    this.orderEmpList = 2;
                } else {
                    this.orderEmpList = 1;
                }
            } else {
                if (this.orderEmpList == 3) {
                    this.orderEmpList = 4;
                } else {
                    this.orderEmpList = 3;
                }
            }
        },
        getAllowenceNameFromId(allowenceId) {
            var a = this.allowenceList.filter(allowence => {
                return allowence.id == allowenceId;
            });
            if (a[0]) {
                return a[0].name;
            } else {
                return "-";
            }
        },
        getWorkGroupNameFromId(workGroupId) {
            var a = this.workGroupList.filter(workGroup => {
                return workGroup.id == workGroupId;
            });
            if (a[0]) {
                return a[0].name;
            } else {
                return "-";
            }
        },
        async changeAllowence(event) {
            if (event.target.value == 0) {
                this.selectedShift.allowenceId = null;
                this.selectedShift.allowenceName = "";
            } else {
                this.selectedShift.allowenceId = event.target.value;
                this.selectedShift.allowenceName = await this.getAllowenceNameFromId(
                    event.target.value
                );
                this.selectedShift.workGroupId = null;
                this.selectedShift.workGroupName = "";
            }
        },
        async changeWorkGroup(event) {
            if (event.target.value == 0) {
                this.selectedShift.workGroupId = null;
                this.selectedShift.workGroupName = "";
            } else {
                this.selectedShift.workGroupId = event.target.value;
                this.selectedShift.workGroupName = await this.getWorkGroupNameFromId(
                    event.target.value
                );
                this.selectedShift.allowenceId = null;
                this.selectedShift.allowenceName = "";
            }
        },
        changeFilterTitles(event) {
            this.filters.title = event.target.value;
        },
        changeFilterExtraField1(event) {
            this.filters.extraField1key = event.target.value;
            if (!this.filters.extraField1key) {
                this.filters.extraField1key = 0;
            }
        },
        changeFilterExtraField2(event) {
            this.filters.extraField2key = event.target.value;
            if (!this.filters.extraField2key) {
                this.filters.extraField2key = 0;
            }
        },
        changeFilterExtraField3(event) {
            this.filters.extraField3key = event.target.value;
            if (!this.filters.extraField3key) {
                this.filters.extraField3key = 0;
            }
        },
        changeFilterExtraField4(event) {
            this.filters.extraField4key = event.target.value;
            if (!this.filters.extraField4key) {
                this.filters.extraField4key = 0;
            }
        },
        filtersClear() {
            this.filters.nameOrCardNumber = "";
            this.filters.sicilOrTerminalNo = null;
            this.filters.departments = [];
            this.filters.accessGroup = [];
            this.filters.identityNo = "";
            this.filters.documentNoOrMail = "";
            this.filters.foodGroup = [];
            this.filters.workGroupId = [];
            this.filters.title = "";
            this.filters.stateId = [];
            this.filters.statuId = [];
            this.filters.plateNo = "";
            this.filters.extraField1key = 0;
            this.filters.extraField1value = "";
            this.filters.extraField2key = 0;
            this.filters.extraField2value = "";
            this.filters.extraField3key = 0;
            this.filters.extraField3value = "";
            this.filters.extraField4key = 0;
            this.filters.extraField4value = "";
            this.filters.isVisitor = false;
            this.filters.isActive = true;
            this.accessGroupList.forEach(a => {
                a.isCheck = false;
            });
            this.sortableDepartmentList.forEach(a => {
                a.check = false;
            });
            this.foodGroupList.forEach(a => {
                a.isCheck = false;
            });
            this.workGroupList.forEach(a => {
                a.isCheck = false;
            });
            this.stateList.forEach(a => {
                a.isCheck = false;
            });
            this.statuList.forEach(a => {
                a.isCheck = false;
            });
        },
        checkListControl(shift, empId) {
            var contextId = this.selectedWorkGroup.id;
            var isAllowence = false;
            if (this.selectedAllowence.id != null) {
                contextId = this.selectedAllowence.id;
                isAllowence = true;
            }
            var date = this.toDateFormat(shift.date, "gg.aa.yyyy");
            var result = this.selectedBatchShiftList.filter(item => {
                return item.contextId == contextId && item.empId == empId && item.date == date;
            });
            if (result.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        selectWorkGroup(workGroup) {
            if (this.selectedWorkGroup.id && this.selectedWorkGroup.id == workGroup.id) {
                this.selectedWorkGroup = { id: null, name: "" };
                this.selectedBatchShiftList = [];
            } else {
                this.selectedWorkGroup.id = workGroup.id;
                this.selectedWorkGroup.name = workGroup.name;
                this.selectedAllowence = { id: null, name: "" };
                alertify.message("Seçilen çalışma grubuna ait planlarda değişiklik yapabilirsiniz.");
            }
        },
        selectAllowence(allowence) {
            if (this.selectedAllowence && this.selectedAllowence.id == allowence.id) {
                this.selectedAllowence = { id: null, name: "" };
                this.selectedBatchShiftList = [];
            } else {
                this.selectedAllowence.id = allowence.id;
                this.selectedAllowence.name = allowence.name;
                this.selectedWorkGroup = { id: null, name: "" };
                alertify.message("Seçilen izin grubuna ait planlarda değişiklik yapabilirsiniz.");
            }
        },
        selectBatchShift(shift) {
            console.log(shift);
            var contextId = this.selectedWorkGroup.id;
            var isAllowence = false;
            if (this.selectedAllowence.id != null) {
                contextId = this.selectedAllowence.id;
                isAllowence = true;
            }
            var date = this.toDateFormat(shift.date, "gg.aa.yyyy");
            var result = this.selectedBatchShiftList.filter(item => {
                if (isAllowence) {
                    return item.contextId == contextId && item.isAllowence == true && item.empId == shift.empId && item.date == date;
                } else {
                    return item.contextId == contextId && item.isAllowence == false && item.empId == shift.empId && item.date == date;
                }
            });
            if (result.length > 0) {
                //Eğer seçili ise selectedBatchShiftList içinden çıkar
                this.selectedBatchShiftList = this.selectedBatchShiftList.filter(item => {
                    if (isAllowence) {
                        return !(item.contextId == contextId && item.isAllowence == true && item.empId == shift.empId && item.date == date);
                    } else {
                        return !(item.contextId == contextId && item.isAllowence == false && item.empId == shift.empId && item.date == date);
                    }
                });
            } else {
                this.selectedBatchShiftList.push({
                    empId: shift.empId,
                    date: date,
                    contextId: parseInt(contextId),
                    isAllowence: isAllowence
                });
            }
            console.log(this.selectedBatchShiftList);
        },
        clearSelectedBatchShift() {
            this.selectedBatchShiftList = [];
            this.selectedWorkGroup = { id: null, name: "" };
            this.selectedAllowence = { id: null, name: "" };
        },
        async saveBatchShift() {
            try {
                this.isLoading = true;
                const response = await this.$axios
                    .post("/Shift/ChangePayroll", this.selectedBatchShiftList)
                    .then(response => {
                        this.getRealMovements();
                        this.clearSelectedBatchShift();
                        alertify.success("İşlem Tamamlandı!");
                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            } else if (error.response.status == 403) {
                                alertify.message(
                                    this.$ml.get("alerts.userIsNotAuthorizedToSeeData")
                                );
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
                this.isLoading = false;
            }
        },
        selectShift(shift, emp) {
            this.selectedShift.id = shift.id;
            this.selectedShift.empId = shift.empId;
            this.selectedShift.date = shift.date;
            this.selectedShift.entry = shift.entry;
            this.selectedShift.exit = shift.exit;
            this.selectedShift.toleranceEntry = shift.toleranceEntry;
            this.selectedShift.toleranceExit = shift.toleranceExit;
            this.selectedShift.allowenceId = shift.allowenceId;
            this.selectedShift.allowenceName = shift.allowenceName;
            this.selectedShift.workGroupId = shift.workGroupId;
            this.selectedShift.workGroupName = shift.workGroupName;
            this.selectedEmployee.empId = emp.empId;
            this.selectedEmployee.title = emp.title;
            this.selectedEmployee.sicilNo = emp.sicilNo;
            this.selectedEmployee.terminalNo = emp.terminalNo;
            this.selectedEmployee.name = emp.name;
            this.getDailyPayrollDetails(shift.date, shift.workGroupName, emp.empId);
            $("#modal-shift").modal("show");
        },
        async getAccessGroups() {
            try {
                const accessGroups = [];
                const response = await this.$axios
                    .get("/AccessGroups")
                    .then(response => {
                        response.data.forEach(doc => {
                            accessGroups.push({
                                id: doc.id,
                                name: doc.name,
                                isNewReaderAdd: doc.isNewReaderAdd,
                                selectedReaders: doc.postReaders,
                                isCheck: false
                            });
                        });
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.accessGroups = accessGroups;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
            }
        },
        async getDepartments() {
            const departments = [];
            try {
                const response = await this.$axios
                    .get("/Department")
                    .then(response => {
                        response.data.forEach(doc => {
                            departments.push({
                                id: doc.id,
                                name: doc.name,
                                mainDepartmentId: doc.mainDepartmentId,
                                isActive: doc.isActive,
                                locationTree: doc.locationTree,
                                check: false
                            });
                        });
                        departments.sort((a, b) => {
                            if (a.locationTree < b.locationTree) return -1;
                            if (a.locationTree > b.locationTree) return 0;
                        });
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.departments = departments;
                this.sortableTrees();
                this.isLoading = false;
            } catch (error) {
                console.error(error);
                alertify.error(error);
            }
        },
        sortableTrees() {
            this.sortableDepTrees = [];
            this.departments.forEach(dep => {
                if (dep.mainDepartmentId == null) {
                    this.sortableDepTrees.push(dep);
                    this.subDepImport(dep);
                }
            });
        },
        subDepImport(dep) {
            let subDep = this.departments.filter(function (doc) {
                return doc.mainDepartmentId == dep.id;
            });
            if (subDep.length > 0) {
                var ekle = "";
                let ek = subDep[0].locationTree.split("/");
                for (let index = 0; index < ek.length - 3; index++) {
                    ekle = "--/" + ekle;
                }
                subDep.forEach(doc2 => {
                    this.sortableDepTrees.push({
                        id: doc2.id,
                        name: ekle + " " + doc2.name,
                        mainDepartmentId: doc2.mainDepartmentId,
                        isActive: doc2.isActive,
                        locationTree: doc2.locationTree,
                        userId: doc2.userId,
                        check: doc2.check
                    });
                    this.subDepImport(doc2);
                });
            }
        },
        async getFoodGroups() {
            try {
                const foodGroups = [];
                const response = await this.$axios
                    .get("/FoodGroups")
                    .then(response => {
                        response.data.forEach(doc => {
                            foodGroups.push({
                                id: doc.id,
                                name: doc.name,
                                type: doc.type,
                                singleFoodEachMeal: doc.singleFoodEachMeal,
                                meals: doc.meals,
                                isCheck: false
                            });
                        });
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.foodGroups = foodGroups;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
            }
        },
        async getStatus() {
            try {
                const status = [];
                const response = await this.$axios
                    .get("/Employees/getStatus")
                    .then(response => {
                        response.data.forEach(doc => {
                            status.push({
                                id: doc.id,
                                name: doc.name,
                                isCheck: false
                            });
                        });
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.status = status;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
            }
        },
        async getTitles() {
            try {
                const titles = [];
                const response = await this.$axios
                    .get("/Employees/getTitles")
                    .then(response => {
                        response.data.forEach(doc => {
                            titles.push({
                                name: doc
                            });
                        });
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.titles = titles;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
            }
        },
        async getStates() {
            try {
                const states = [];
                const response = await this.$axios
                    .get("/Employees/getStates")
                    .then(response => {
                        response.data.forEach(doc => {
                            states.push({
                                id: doc.id,
                                name: doc.name,
                                status: doc.status,
                                isCheck: false
                            });
                        });
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.states = states;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
            }
        },
        async getWorkGroups() {
            try {
                const workGroups = [];
                const response = await this.$axios
                    .get("/WorkGroups")
                    .then(response => {
                        response.data.forEach(doc => {
                            workGroups.push({
                                id: doc.id,
                                name: doc.name,
                                shortCode: doc.shortCode,
                                isPeriod: doc.isPeriod,
                                model: doc.model,
                                isCheck: false
                            });
                            workGroups.sort((a, b) => {
                                if (a.name < b.name) return -1;
                                if (a.name > b.name) return 0;
                            });
                        });
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.workGroups = workGroups;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
            }
        },
        async getExtraFields() {
            try {
                const extrafields = [];
                const response = await this.$axios
                    .get("/ExtraField")
                    .then(response => {
                        response.data.forEach(doc => {
                            extrafields.push({
                                id: doc.id,
                                name: doc.definition
                            });
                        });
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.extrafields = extrafields;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
            }
        },
        async changeFilterDep(dep, checkValue) {
            dep.check = checkValue;
            this.sortableDepartmentList.forEach(doc => {
                if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    this.changeFilterDep(doc, checkValue);
                }
            });
        },
        async clearFilterDepartments() {
            this.filters.departments = [];
            await this.sortableDepartmentList.forEach(doc => {
                if (doc.check == true) {
                    doc.check = false;
                }
            });
        },
        async clearFilterAccessGroup() {
            this.filters.accessGroup = [];
            await this.accessGroupList.forEach(doc => {
                if (doc.isCheck == true) {
                    doc.isCheck = false;
                }
            });
        },
        async clearFilterStates() {
            this.filters.stateId = [];
            await this.stateList.forEach(doc => {
                if (doc.isCheck == true) {
                    doc.isCheck = false;
                }
            });
        },
        async clearFilterStatus() {
            this.filters.statuId = [];
            await this.statuList.forEach(doc => {
                if (doc.isCheck == true) {
                    doc.isCheck = false;
                }
            });
        },
        async clearFilterWorkPlans() {
            this.filters.workGroupId = [];
            await this.workGroupList.forEach(doc => {
                if (doc.isCheck == true) {
                    doc.isCheck = false;
                }
            });
        },
        async clearFilterFoodGroups() {
            this.filters.foodGroup = [];
            await this.foodGroupList.forEach(doc => {
                if (doc.isCheck == true) {
                    doc.isCheck = false;
                }
            });
        },
        async getCheckDepartmentAll(value) {
            this.sortableDepartmentList.forEach(dep => {
                dep.check = value;
            });
            this.isCheckDeps = !this.isCheckDeps;
        },
        async getCheckDepartmentList() {
            let aList = this.sortableDepartmentList;
            this.filters.departments = [];
            await aList.forEach(doc => {
                if (doc.check == true) {
                    this.filters.departments.push(doc.id);
                }
            });
            let aList2 = this.accessGroupList;
            this.filters.accessGroup = [];
            await aList2.forEach(doc => {
                if (doc.isCheck == true) {
                    this.filters.accessGroup.push(doc.id);
                }
            });
            let aList3 = this.workGroupList;
            this.filters.workGroupId = [];
            await aList3.forEach(doc => {
                if (doc.isCheck == true) {
                    this.filters.workGroupId.push(doc.id);
                }
            });
            let aList4 = this.foodGroupList;
            this.filters.foodGroup = [];
            await aList4.forEach(doc => {
                if (doc.isCheck == true) {
                    this.filters.foodGroup.push(doc.id);
                }
            });
            let aList5 = this.statuList;
            this.filters.statuId = [];
            await aList5.forEach(doc => {
                if (doc.isCheck == true) {
                    this.filters.statuId.push(doc.id);
                }
            });
            let aList6 = this.stateList;
            this.filters.stateId = [];
            await aList6.forEach(doc => {
                if (doc.isCheck == true) {
                    this.filters.stateId.push(doc.id);
                }
            });
        },
        async getEmployees() {
            try {
                this.isLoading = true;
                await this.getCheckDepartmentList();
                const employees = [];
                let filters2 = this.filters;
                const response = await this.$axios
                    .post("/Employees/getByFilter", {
                        nameOrCardNumber: filters2.nameOrCardNumber,
                        sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                        departments: filters2.departments,
                        accessGroup: filters2.accessGroup,
                        identityNo: filters2.identityNo,
                        documentNoOrMail: filters2.documentNoOrMail,
                        foodGroup: filters2.foodGroup,
                        workGroupId: filters2.workGroupId,
                        title: filters2.title,
                        stateId: filters2.stateId,
                        statuId: filters2.statuId,
                        plateNo: filters2.plateNo,
                        extraField1key: filters2.extraField1key,
                        extraField1value: filters2.extraField1value,
                        extraField2key: filters2.extraField2key,
                        extraField2value: filters2.extraField2value,
                        extraField3key: filters2.extraField3key,
                        extraField3value: filters2.extraField3value,
                        extraField4key: filters2.extraField4key,
                        extraField4value: filters2.extraField4value,
                        isVisitor: filters2.isVisitor,
                        isActive: filters2.isActive
                    })
                    .then(response => {
                        response.data.forEach(doc => {
                            employees.push({
                                id: doc.id,
                                name: doc.name,
                                sicilNo: doc.sicilNo,
                                title: doc.title,
                                check: false
                            });
                        });
                        //this.filtersClear();
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            } else if (error.response.status == 403) {
                                alertify.message(
                                    this.$ml.get("alerts.userIsNotAuthorizedToSeeData")
                                );
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.employees = employees;
                this.isLoading = false;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
                this.isLoading = false;
            }
        },
        async getAllowences() {
            try {
                const allowences = [];
                const response = await this.$axios
                    .get("/Allowences")
                    .then(response => {
                        response.data.forEach(doc => {
                            allowences.push({
                                id: doc.id,
                                shortCode: doc.shortCode,
                                name: doc.name,
                                monthlyPayrollId: doc.monthlyPayrollId,
                                dailyPayrollId: doc.dailyPayrollId,
                                dayTime: doc.dayTime,
                                colorCode: doc.colorCode,
                                r: doc.r,
                                g: doc.g,
                                b: doc.b
                            });
                        });
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.allowences = allowences;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
            }
        },
        async saveChangePayroll() {
            try {
                this.isLoading = true;
                var contextId = this.selectedShift.workGroupId;
                var isAllowence = false;
                if (this.selectedShift.allowenceId) {
                    contextId = this.selectedShift.allowenceId;
                    isAllowence = true;
                }
                var date = this.toDateFormat(this.selectedShift.date, "gg.aa.yyyy");
                var data = [];
                data.push({
                    empId: this.selectedShift.empId,
                    date: date,
                    contextId: parseInt(contextId),
                    isAllowence: isAllowence
                });
                const response = await this.$axios
                    .post("/Shift/ChangePayroll", data)
                    .then(response => {
                        this.getRealMovements();
                        $("#modal-shift").modal("hide");
                        alertify.success("İşlem Tamamlandı!");
                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            } else if (error.response.status == 403) {
                                alertify.message(
                                    this.$ml.get("alerts.userIsNotAuthorizedToSeeData")
                                );
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
                this.isLoading = false;
            }
        },
        async getSelectedEmployeeList() {
            var idList = [];
            await this.employeeList.forEach(emp => {
                idList.push(emp.id);
            });
            return idList;
        },
        async getRealMovements() {
            try {
                this.isLoading = true;
                let empIds = await this.getSelectedEmployeeList();
                var shifts = [];
                const response = await this.$axios
                    .post("/Webshift/RealMovements", {
                        employeeIds: empIds,
                        year: this.year,
                        monthOrWeekNumber: this.monthOrWeekNumber,
                        isMonth: false
                    })
                    .then(response => {
                        shifts = response.data;
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.shifts = shifts;
                this.isLoading = false;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
                this.isLoading = false;
            }
        },
        async getShifts() {
            try {
                this.isLoading = true;
                let empIds = await this.getSelectedEmployeeList();
                var shifts = [];
                const response = await this.$axios
                    .post("/Webshift/GetShift", {
                        employeeIds: empIds,
                        year: this.year,
                        monthOrWeekNumber: this.monthOrWeekNumber,
                        isMonth: false
                    })
                    .then(response => {
                        shifts = response.data;
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.shifts = shifts;
                this.isLoading = false;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
                this.isLoading = false;
            }
        },
        setUserAuthorityFilter(filter) {
            filter.accessGroup
                ? (this.filters.accessGroup = filter.accessGroup)
                : (this.filters.accessGroup = []);
            filter.foodGroup
                ? (this.filters.foodGroup = filter.foodGroup)
                : (this.filters.foodGroup = []);
            filter.workGroupId
                ? (this.filters.workGroupId = filter.workGroupId)
                : (this.filters.workGroupId = []);
            filter.stateId
                ? (this.filters.stateId = filter.stateId)
                : (this.filters.stateId = []);
            filter.statuId
                ? (this.filters.statuId = filter.statuId)
                : (this.filters.statuId = []);
            this.filters.departments = filter.departments;
            this.filters.nameOrCardNumber = filter.nameOrCardNumber;
            this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
            this.filters.isActive = filter.isActive;
            this.filters.documentNoOrMail = filter.documentNoOrMail;
            this.filters.identityNo = filter.identityNo;
            this.filters.title = filter.title;
            this.filters.extraField1key = filter.extraField1key;
            this.filters.extraField1value = filter.extraField1value;
            this.filters.extraField2key = filter.extraField2key;
            this.filters.extraField2value = filter.extraField2value;
            this.filters.extraField3key = filter.extraField3key;
            this.filters.extraField3value = filter.extraField3value;
            this.filters.extraField4key = filter.extraField4key;
            this.filters.extraField4value = filter.extraField4value;
            this.filters.isVisitor = filter.isVisitor;
            this.filters.plateNo = filter.plateNo;
            //this.filters = filter;
            this.sortableDepartmentList.forEach(doc => {
                this.filters.departments.forEach(doc2 => {
                    if (doc.id == doc2) {
                        doc.check = true;
                    }
                });
            });
            this.periodWorkGroupList.forEach(doc => {
                this.filters.workGroupId.forEach(doc2 => {
                    if (doc.id == doc2) {
                        doc.isCheck = true;
                    }
                });
            });
            this.accessGroupList.forEach(doc => {
                this.filters.accessGroup.forEach(doc2 => {
                    if (doc.id == doc2) {
                        doc.isCheck = true;
                    }
                });
            });
            this.foodGroupList.forEach(doc => {
                this.filters.foodGroup.forEach(doc2 => {
                    if (doc.id == doc2) {
                        doc.isCheck = true;
                    }
                });
            });
            this.stateList.forEach(doc => {
                this.filters.stateId.forEach(doc2 => {
                    if (doc.id == doc2) {
                        doc.isCheck = true;
                    }
                });
            });
            this.statuList.forEach(doc => {
                this.filters.statuId.forEach(doc2 => {
                    if (doc.id == doc2) {
                        doc.isCheck = true;
                    }
                });
            });
        },
        async getCalendar() {
            try {
                this.isLoading = true;
                var days = [];
                const response = await this.$axios
                    .get(
                        "/Webshift/Calendar?year=" +
                        this.year +
                        "&monthOrWeekNumber=" +
                        this.monthOrWeekNumber +
                        "&isMonth=false"
                    )
                    .then(response => {
                        days = response.data.dates;
                        this.isForbidden = response.data.isForbidden;
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.selectedDays = days;
                this.isLoading = false;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası :" + error.message);
                this.isLoading = false;
            }
        },
        changeInOutDoor2(event) {
            this.inOut2.readerId = event.target.value;
            var filtered = this.readers.filter(doc => doc.readerId == event.target.value);
            if (filtered.length > 0) {
                this.inOut2.inOutType = filtered[0].inOrOut;
                this.selectedDoorTypeMovement = filtered[0].inOrOut;
            }
        },
        changeInOutType2(event) {
            this.inOut2.inOutType = event.target.value;
            this.selectedDoorTypeMovement = event.target.value;
        },
        newInOut2() {
            this.isNewInOut2 = true;
            this.isActiveInOut2 = true;
            var date = this.toDateFormat(this.selectedDailyPayrol.date, "gg.aa.yyyy");
            var docc = date.split(".");
            this.inOut2.inOutAdd = docc[2] + "-" + docc[1] + "-" + docc[0] + "T00:00";
            this.inOut2.inOutType = 0;
            this.selectedDoorTypeMovement = 0;
            this.inOut2.readerId = "0";
            this.inOut2.inOutId = null;
            if (this.readers.length > 0) {
                this.inOut2.readerId = this.activePDKSReaderList[0].readerId;
                this.inOut2.inOutType = this.activePDKSReaderList[0].inOrOut;
            }
        },
        selectInOut2(inOutDetail) {
            this.isNewInOut2 = false;
            this.isActiveInOut2 = true;
            this.inOut2.inOutId = inOutDetail.id;
            this.inOut2.inOutType = inOutDetail.inOrOut;
            this.selectedDoorTypeMovement = inOutDetail.inOrOut;
            this.inOut2.inOutAdd = this.toDateFormat(inOutDetail.unFormattedDate, "yyyy-aa-ggTss:dd");
            this.inOut2.readerId = inOutDetail.readerId;
        },
        async addInOut2() {
            if (this.inOut2.inOutAdd == "") {
                alertify.warning(this.$ml.get("alerts.invalidDate"));
                return;
            }
            if (this.inOut2.readerId == "" || this.inOut2.readerId == 0) {
                alertify.warning(this.$ml.get("alerts.notSelectedReader"));
                return;
            }
            var date = new Date(this.inOut2.inOutAdd);
            var today = new Date();
            if (date > today) {
                alertify.warning(
                    this.$ml.get("alerts.cannotCreateMovementInTheFuture")
                );
                return;
            }
            try {
                let empId = this.selectedEmployee.empId;
                let inOurOut = this.inOut2.inOutType;
                let inOutAdd = this.inOut2.inOutAdd;
                let readerId = this.inOut2.readerId;
                const response = await this.$axios
                    .post("/EmployeeDetails/AddEntryExit", {
                        isActive: true,
                        inOrOut: inOurOut,
                        date: inOutAdd,
                        readerId: readerId,
                        includePassiveMovements: this.includePassiveMovements,
                        doNotDeleteOvertimes: this.doNotDeleteOvertimes,
                        empId: empId
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                        }
                        if (
                            error.message == "Network Error" ||
                            error.message == "Error: Network Error"
                        ) {
                            alertify.error(this.$ml.get("errors.connectionError"));
                            this.isLoadingInOuts = false;
                            return;
                        } else {
                            console.error(error);
                            alertify.error(error.message);
                            this.isLoadingInOuts = false;
                            return;
                        }
                    });
                if (response.status == 200) {
                    alertify.success(this.$ml.get("alerts.savedSuccessfully"));
                } else {
                    alertify.error(response.message);
                }
                this.newInOut2();
                this.isActiveInOut2 = false;
                this.getDailyPayrollDetails(this.selectedShift.date, this.selectedShift.workGroupName, this.selectedEmployee.empId);
            } catch (error) {
                console.error(error);
                alertify.error(error.message);
            }
        },
        async updateInOut2() {
            if (this.inOut2.inOutAdd == "") {
                alertify.warning(this.$ml.get("alerts.invalidDate"));
                return;
            }
            if (this.inOut2.readerId == "" || this.inOut2.readerId == 0) {
                alertify.warning(this.$ml.get("alerts.notSelectedReader"));
                return;
            }
            var date = new Date(this.inOut2.inOutAdd);
            var today = new Date();
            if (date > today) {
                alertify.warning(
                    this.$ml.get("alerts.cannotCreateMovementInTheFuture")
                );
                return;
            }
            try {
                let empId = this.selectedEmployee.empId;
                let inOurOut = this.inOut2.inOutType;
                let inOutAdd = this.inOut2.inOutAdd;
                let readerId = this.inOut2.readerId;
                const response = await this.$axios.post(
                    "/EmployeeDetails/UpdateEntryExit/" + this.inOut2.inOutId,
                    {
                        isActive: true,
                        inOrOut: inOurOut,
                        date: inOutAdd,
                        empId: empId,
                        readerId: readerId
                    }
                );
                if (response.status == 200) {
                    alertify.success(this.$ml.get("alerts.savedSuccessfully"));
                } else {
                    alertify.error(response.message);
                }
                this.newInOut2();
                this.isActiveInOut2 = false;
                this.getDailyPayrollDetails(this.selectedShift.date, this.selectedShift.workGroupName, this.selectedEmployee.empId);
            } catch (error) {
                console.error(error);
                alertify.error(error.message);
            }
        },
        async deleteInOut2(id) {
            try {
                if (id != 0) {
                    const response = await this.$axios
                        .delete("/EmployeeDetails/DeleteEntryExit/" + id)
                        .then(response => {
                            alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
                        })
                        .catch(error => {
                            if (error.response) {
                                if (error.response.status == 401) {
                                    this.$store.dispatch("logout");
                                }
                            }
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoadingInOuts = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoadingInOuts = false;
                                return;
                            }
                        });
                    this.getDailyPayrollDetails(this.selectedShift.date, this.selectedShift.workGroupName, this.selectedEmployee.empId);
                }
            } catch (error) {
                alertify.error("Hata Oluştu : " + error);
            }
        },
        changeOvertimePlace(event) {
            this.selectedOTPlaceId = event.target.value;
        },
        changeOvertimeDescription(event) {
            this.selectedOTDescriptionId = event.target.value;
        },
        async customConfirmOverTime() {
            try {
                let id = this.selectedDailyPayrol.overTimeId;
                let calculatedDate =
                    "1900-01-01T" + this.selectedDailyPayrol.calculatedOverTime + ":00";
                let confirmedDate =
                    "1900-01-01T" +
                    this.selectedDailyPayrol.confirmedOverTime.replace("Z", "");
                if (confirmedDate > calculatedDate) {
                    alertify.warning(
                        this.$ml.get(
                            "alerts.confirmedOvertimeCannotBeGreaterThanCalculated"
                        )
                    );
                    return;
                }
                this.isLoading = true;
                const response = await this.$axios
                    .post("/EmployeeDetails/CustomConfirmOvertime", {
                        id: id,
                        confirmedDate: confirmedDate,
                        overtimeDescriptionId: this.selectedOTDescriptionId,
                        overtimePlaceId: this.selectedOTPlaceId
                    })
                    .then(response => {
                        if (response.status == 200) {
                            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
                            this.isLoading = false;
                        }
                    })
                    .catch(doc => {
                        if (doc.status == 401) {
                            this.$store.dispatch("logout");
                        } else if (doc.message == "Network Error") {
                            alertify.error(this.$ml.get("errors.connectionError"));
                        } else {
                            alertify.error(doc.message);
                        }
                    });
                this.getDailyPayrollDetails(this.selectedShift.date, this.selectedShift.workGroupName, this.selectedEmployee.empId);
            } catch (error) {
                console.error(error);
                alertify.error(error.message);
            }
        },
        async getDailyPayrollDetails(tarih, workGroup, empId) {
            try {
                this.selectedDailyPayrol.date = "";
                this.selectedDailyPayrol.movements = [];
                this.selectedDailyPayrol.workGroup = "";
                this.selectedDailyPayrol.payrolls = [];
                this.selectedDailyPayrol.calculatedOverTime = "00:00";
                this.selectedDailyPayrol.confirmedOverTime = "00:00";
                this.selectedDailyPayrol.overTimeId = null;
                var date = this.toDateFormat(tarih, "gg.aa.yyyy");
                this.selectedDailyPayrol.date = tarih;
                this.selectedDailyPayrol.workGroup = workGroup;
                const response = await this.$axios
                    .post("/EmployeeDetails/GetDailyPayrollDetails", {
                        date: date,
                        empId: empId
                    })
                    .then(response => {
                        if (response.status == 200) {
                            if (response.data.overtimes) {
                                this.selectedDailyPayrol.calculatedOverTime =
                                    response.data.overtimes.calculated;
                                this.selectedDailyPayrol.confirmedOverTime = response.data
                                    .overtimes.confirmed
                                    ? response.data.overtimes.confirmed
                                    : "";
                                this.selectedDailyPayrol.overTimeId =
                                    response.data.overtimes.overTimeId;
                            }
                            response.data.movements.forEach(doc => {
                                this.selectedDailyPayrol.movements.push({
                                    id: doc.id,
                                    unFormattedDate: doc.unFormattedDate,
                                    readerId: doc.readerId,
                                    inOrOut: doc.inOrOut,
                                    date: doc.date,
                                    status: doc.status
                                });
                            });
                            response.data.payrolls.forEach(doc => {
                                this.selectedDailyPayrol.payrolls.push({
                                    time: doc.time,
                                    payroll: doc.payroll
                                });
                            });
                        }
                    })
                    .catch(doc => {
                        if (doc.status == 401) {
                            this.$store.dispatch("logout");
                        } else if (doc.message == "Network Error") {
                            alertify.error(this.$ml.get("errors.connectionError"));
                        } else {
                            alertify.error(doc.message);
                        }
                    });
            } catch (error) {
                console.error(error);
                alertify.error(error.message);
            }
        },
        async getReaders() {
            try {
                const readers = [];
                const response = await this.$axios
                    .get("/Terminal/GetReaders")
                    .then(response => {
                        if (response.status == 200) {
                            response.data.forEach(doc => {
                                if (
                                    doc.doorType == 0 ||
                                    doc.doorType == 1 ||
                                    doc.doorType == 2 ||
                                    doc.doorType == 3 ||
                                    doc.doorType == 5
                                ) {
                                    readers.push({
                                        readerNo: doc.readerNo,
                                        readerId: doc.readerId,
                                        terminalId: doc.terminalId,
                                        terminalNo: doc.terminalNo,
                                        ipAddress: doc.ipAddress,
                                        isActive: doc.isActive,
                                        doorType: doc.doorType,
                                        name: doc.name,
                                        inOrOut: doc.inOrOut,
                                        check: false,
                                        VCGcheck: false
                                    });
                                }
                            });
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("logout");
                            }
                            if (error.response.status == 500) {
                                alertify.error(this.$ml.get("alerts.getReadersError"));
                                this.isLoading = false;
                            }
                        } else {
                            if (
                                error.message == "Network Error" ||
                                error.message == "Error: Network Error"
                            ) {
                                alertify.error(this.$ml.get("errors.connectionError"));
                                this.isLoading = false;
                                return;
                            } else {
                                console.error(error);
                                alertify.error(error.message);
                                this.isLoading = false;
                                return;
                            }
                        }
                    });
                this.readers = readers;
            } catch (error) {
                console.error(error);
                alertify.error("Servis Hatası : " + error.message);
            }
        },
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    async created() {
        await this.getDepartments();
        await this.getAccessGroups();
        if (this.modules.diningHall) {
            await this.getFoodGroups();
        }
        await this.getStatus();
        await this.getStates();
        await this.getTitles();
        await this.getWorkGroups();
        await this.getExtraFields();
        await this.getAllowences();
        await this.getReaders();
        $("body").addClass("sidebar-collapse"); //Sidebar kapatılarak tam ekrana geçiliyor
        let curr = new Date();
        let week = [];
        for (let i = 2; i <= 8; i++) {
            //Bu haftanın günleri week adlı array içine diziliyor
            let first = curr.getDate() - curr.getDay() + i;
            let day = new Date(curr.setDate(first)).toISOString().slice(0, 10);
            week.push(day);
        }
        this.startDateNow = new Date(week[0] + " 00:00");
        this.endDateNow = new Date(week[6] + " 23:59");
        await this.startDateNow.setDate(this.startDateNow.getDate() + 7); // Shift düzenleme başlangıcı bir hafta sonrası
        await this.endDateNow.setDate(this.endDateNow.getDate() + 7); // Shift düzenleme sonu bir hafta sonrası + pazartesi
        var startDateOfYear = null; //YILIN İLK PAZARTESİ GÜNÜ
        for (let i = 0; i < 7; i++) {
            var a = new Date(this.startDateNow.getFullYear(), 0, i);
            if (
                a.toLocaleString("default", { weekday: "long" }) == "Pazartesi" ||
                a.toLocaleString("default", { weekday: "long" }) == "Monday"
            ) {
                startDateOfYear = a;
                i = 7;
            }
        }
        var days = await Math.floor(
            (this.startDateNow - startDateOfYear) / (24 * 60 * 60 * 1000)
        );
        var weekNumber = (await Math.ceil(days / 7));
        this.year = this.startDateNow.getFullYear();
        this.monthOrWeekNumber = weekNumber;
        var weekNumber2 = "0";
        if (weekNumber < 10) {
            weekNumber2 = "0" + weekNumber;
        } else {
            weekNumber2 = weekNumber;
        }
        this.selectedWeek = this.startDateNow.getFullYear() + "-W" + weekNumber2;
        if (this.defaultFilters) {
            var filter = this.defaultFilters;
            await this.setUserAuthorityFilter(filter);
            await this.getEmployees();
        }
        //await this.getDateOfIsOWeek(this.selectedWeek);
    }
};
</script>
<style scoped>
.default-label {
    background-color: #ecf0f5;
    color: #333333;
}

.selecting-hover:hover {
    background-color: #136edc;
    color: #ffffff;
}

.selected-shift {
    background-color: #136edc;
    color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/payrollManagement/PayrollShiftManagement.vue